<template>
  <div v-if="show"
  class="overflow-y-auto bg-[#00000080] overflow-x-hidden fixed w-screen h-screen top-0 left-0 py-4 z-50 justify-center items-center tw-flex"
  aria-modal="true" role="dialog">
    <div class="relative rounded-bl-[8px] rounded-br-[8px]" style="width: 765px">
      <div class="rounded-tl-[16px] rounded-tr-[16px] bg-[#fff] p-[10px]">
        <div class="tw-flex items-center pb-[16px]  font-normal border-b border-[#296B2D]  gap-[14px]">
          <span class="font-bold text-18">
          </span>
        </div>
        <button @mousedown="close" type="button" data-modal-toggle="defaultModal" class="absolute right-[46px] top-[16px] cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="13.121" height="13.121" viewBox="0 0 13.121 13.121">
          <g id="Grupo_23802" data-name="Grupo 23802" transform="translate(-1096.439 -193.439)">
          <line id="Línea_1862" data-name="Línea 1862" x1="11" y2="11" transform="translate(1097.5 194.5)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.5"/>
          <line id="Línea_1863" data-name="Línea 1863" x2="11" y2="11" transform="translate(1097.5 194.5)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.5"/>
          </g>
          </svg>
        </button>
      </div>
      <div class="bg-[#fff] rounded-bl-[16px] rounded-br-[16px]">
        <div class="px-[16px] ">
          <p class="text-12"><translate>Latest analysis</translate>
            {{ $moment(dateLatestAnalysis).format('DD/MM/YYYY') }}</p>
          <div class="text-14 rounded-[8px] bg-[#EDE8FF] px-[16px] py-[12px] tw-flex items-center">
            <p class="font-semibold mb-0 flex-1">
              {{ question }}
            </p>
            <div v-if="questionType === 'direct'" class="tw-flex items-center gap-2">
              <img :src="getImageByScoreLLM(scoreGlobal)" class="h-[14px]" alt=""  />
              <span :style="{color: getColorByScore(scoreGlobal)}" class="font-semibold text-13">
                  {{ scoreGlobal | formatNumber(2,2) }}
                </span>
            </div>
          </div>

          <div class="mt-[16px] grid gap-2 self-stretch" style="grid-template-columns: repeat(auto-fit, minmax(0, 1fr))">
            <div v-for="(llm, index) in llms"
                 :key="index"
                 class="tw-flex flex-col p-[10px] items-center justify-center rounded-[8px] border gap-2 cursor-pointer"

                 :class="{'bg-[#F2F2F2] border-[#f2f2f2]': active !== llm, 'bg-[#EDE8FF] border-[#9680E0]': active === llm}"
                 @click="active = llm"
            >
              <div style="height: 30px">
                <img :src="getLogoByLLM(llm)" class="w-[80px]" >

              </div>
              <div v-if="questionType === 'direct'" class="tw-flex items-center justify-center gap-2">
                <img :src="getImageByScoreLLM(getScore(llm))" class="h-[14px]" alt=""  />
                <span :style="{color: getColorByScore(getScore(llm))}" class="font-semibold text-13">
                  {{ getScore(llm) | formatNumber(2,2) }}
                </span>
              </div>
              <div v-else>
                <img :src="verifyIndirectPromptsVisibility(question, llm)" class="h-[14px]" alt=""  />
              </div>
            </div>
          </div>

          <div class="mt-[16px] p-[12px] text-12 p-[10px] scrollCustomIA overflow-y-auto rounded-[8px] border border-[#EDE8FF]"
               style="height: 357px;"
               v-html="renderedMarkdown"
          >
          </div>
        </div>
        <div class="bg-[#ffffff]  rounded-bl-[16px] rounded-br-[16px] tw-flex items-center justify-center pt-[29px]">
          <slot name="footer">
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixinIAReputation from "@/mixins/iareputation.js"
import { marked } from 'marked';

export default {
  mixins: [MixinIAReputation],
    props: {
      data: {
        default: null
      },
      question: {
        default: null
      },
      show: {
        default: false
      }
    },
  data() {
    return {
      active: 'openai'
    }
  },
  computed: {
    renderedMarkdown() {
      return marked(this.answer);
    },
    dateLatestAnalysis () {
      if (!this.data) return ''
      return this.data.created_at
    },
    answer () {
      if (!this.data) { return ''}
      let question
      if (this.data.reputation_index[this.active].prompts_answers.direct.some(e => e.text === this.question)) {
        question = this.data.reputation_index[this.active].prompts_answers.direct.filter(e => e.text === this.question)[0]
      }
      if (this.data.reputation_index[this.active].prompts_answers.indirect.some(e => e.text === this.question)) {
        question = this.data.reputation_index[this.active].prompts_answers.indirect.filter(e => e.text === this.question)[0]
      }
     return question.answer
    },
    questionType () {
      if (!this.data) { return ''}
      if (this.data.reputation_index[this.active].prompts_answers.direct.some(e => e.text === this.question)) {
        return 'direct'
      }
      if (this.data.reputation_index[this.active].prompts_answers.indirect.some(e => e.text === this.question)) {
        return 'indirect'
      }
      return null
    },
    scoreGlobal () {
      if (this.questionType === 'direct') {
        return this.getScoreGlobalByQuestionDirectByLLM(this.question)
      }
      if (this.questionType === 'indirect') {
        return this.getScoreGlobalByQuestionIndirectByLLM(this.question)
      }
      return 0
    }
  },
  methods: {
    getScore (llm) {
      if (this.questionType === 'direct') {
        return this.getScoreByQuestionDirectByLLM(llm, this.question)
      }
      if (this.questionType === 'indirect') {
        return this.getScoreByQuestionIndirectByLLM(llm, this.question)
      }
    },
      close() {
        this.$emit('update:show', false)
      }
  }
}
</script>

<style lang="scss" scoped>
#headModalExcededLimit {
    background-color: #DBE1E1;
}

.close-modal {
    position: absolute;
    top: 15px;
    right: 15px;
}

.icoWarning {
    margin-bottom: -70px;
}

.boxInfo {
    color: #4D4F5C;
    font-size: 1rem;
}</style>
